@let _matches = numberOfMatches();
@let _index = indexDisplay();
@let _value = value();
<div
	class="ada-container ada-col-1 ada-colspan-1"
	[style.gap]="'4px'"
>
	<ada-input
		data-testid="search-navigation-input"
		showAsFullWidth="true"
		[debounce]="debounce()"
		[placeholder]="placeholder()"
		[style.flex]="1"
		[(value)]="value"
		(keydown)="navigateOnSubmit($event)"
	/>
	@if (showNavigation()) {
		<button
			aria-label="Previous Result"
			class="ada-btn ada-btn-sm ada-btn-icon ada-btn-flat ada-btn-no-margin ada-btn-no-padding"
			data-testid="search-navigation-previous-button"
			title="Previous Result"
			(click)="previous()"
		>
			<ada-icon
				ada-color="foreground"
				icon="faAngleUpOutline"
			/>
		</button>
		<button
			aria-label="Next Result"
			class="ada-btn ada-btn-sm ada-btn-icon ada-btn-flat ada-btn-no-margin ada-btn-no-padding"
			data-testid="search-navigation-next-button"
			title="Next Result"
			(click)="next()"
		>
			<ada-icon
				ada-color="foreground"
				icon="faAngleDownOutline"
			/>
		</button>
		@if (_value) {
			<div
				class="ada-flex-center"
				data-testid="search-navigation-display"
				[style.width]="matchDisplayWidth()"
			>
				@if (_matches !== null) {
					<span
						ada-color="foreground"
						class="ada-type-small"
						data-testid="search-navigation-counter"
					>
						{{ _index }}/{{ _matches }}
					</span>
				} @else {
					<ada-spinner
						colSpan="0"
						data-testid="search-navigation-spinner"
						size="small"
					/>
				}
			</div>
		}
	}
	<button
		aria-label="Close Search"
		class="ada-btn ada-btn-sm ada-btn-icon ada-btn-flat ada-btn-no-margin ada-btn-no-padding"
		data-testid="search-navigation-close-button"
		title="Close Search"
		(click)="close.emit()"
	>
		<ada-icon
			ada-color="foreground"
			icon="faTimes"
		/>
	</button>
</div>
